import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {saveAs} from 'file-saver';
import {DatePipe} from '@angular/common';
import {CurrencyConverterPipe} from '../../../utils/pipes/currency-converter.pipe';
import {ExcelExportService} from '../../../utils/services/excel-export.service';
import {HeaderService} from '../../../utils/services/header.service';
import { default as html2canvas }from 'html2canvas';


@Component({
  selector: 'app-head-actions',
  templateUrl: './head-actions.component.html',
  styleUrls: ['./head-actions.component.css'],
  providers: [CurrencyConverterPipe]
})
export class HeadActionsComponent implements OnInit {
  title = '';

  constructor(private router: Router,
              private headerService: HeaderService,
              private datePipe: DatePipe,
              public exportService: ExcelExportService) {
  }

  ngOnInit() {
    this.headerService.title.subscribe(title => {
      this.title = title;
    });
  }

  onExportToExcelClick() {
    this.exportService.startExport();
  }

  onPrintScreenClick() {
    const dateString = this.datePipe.transform(new Date(), 'MMddyyyy_HHmm');

    // to hide buttons from Map screenshot
    this.mapViewButtons('hidden');

    // to make printed chart backgrounds white
    let rectElements = Array.from(document.getElementsByTagName('rect'));
    if (rectElements.length > 0) {
      rectElements.forEach(rect => {
        rect.setAttribute('fill', '#ffffff');
      });
    }

    html2canvas(document.body).then(function (canvas) {
      canvas.toBlob(function (blob) {
        saveAs(blob, 'Verity_Printscreen_' + dateString + '.png');
      });
    });

    this.mapViewButtons('visible');
  }

  isBackToPricesVisible() {
    return !this.router.url.endsWith('/prices-view');
  }

  mapViewButtons(status: string) {
    if (this.title === 'Verity Prices - Map View') {
      const colorpicker = document.getElementById('colorpicker-container');
      const exportBtn = document.getElementById('mapExportBtn');
      colorpicker.style.visibility = status;
      exportBtn.style.visibility = status;
    }
  }
}
